import assert from 'assert';
import Masonry from 'masonry-layout';

/**
 * Masonry-logic for work-page
 */

export default function initWorkMasonry (
  containerSelector,
  itemSelector,
  gridSizerSelector
  ) {
  assert(containerSelector, 'containerSelector must not be null');
  assert(itemSelector, 'itemSelector must not be null');
  assert(gridSizerSelector, 'gridSizerSelector must not be null');

  const workMasonry = new Masonry(containerSelector, {
    columnWidth: gridSizerSelector,
    itemSelector: itemSelector,
    percentPosition: true,
    transitionDuration: 0
  });

  return Promise.resolve({
    destroy: () => {
      workMasonry.destroy();
    }
  });
}
